import { FlagSVG } from "./FlagIcon.styles";

function FlagIcon({ countryCode }: { countryCode: string }): JSX.Element {
  return (
    <FlagSVG>
      <use
        xlinkHref={`/static/images/flags-sprite.svg#${countryCode.toLowerCase()}`}
      />
    </FlagSVG>
  );
}

export { FlagIcon };
